import client from "../client";
import { store } from "../../store";
import { memberActionTypes } from "lib/store/member/reducer";
import { setCookies } from "cookies-next";
import { TIME_COOKIES } from "lib/config/global";

export interface LoginRequest {
  username?: string;
  password?: string;
  id?: string;
  digits?: string;
  nonflag?: string;
}

export interface LoginResponse {
  access_token?: string;
  refresh_token?: string;
}

export default function API(request: LoginRequest): Promise<LoginResponse> {
  return client
    .post(`auth/login`, request)
    .then((response) => response.data)
    .then((json: LoginResponse) => {
      setCookies("access_token", json.access_token, { maxAge: TIME_COOKIES });
      setCookies("refresh_token", json.refresh_token, { maxAge: TIME_COOKIES });
      localStorage.setItem("access_token", json.access_token ?? "");
      store.dispatch({
        type: memberActionTypes.ACTION_USER_LOGIN,
        payload: json,
      });
      return json;
    });
}
